import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export default function NFTMediaContainer(t0) {
  const $ = _c(5);
  const {
    children,
    className,
    forceIronBackground: t1,
    textCenter: t2
  } = t0;
  const forceIronBackground = t1 === undefined ? true : t1;
  const textCenter = t2 === undefined ? false : t2;
  const t3 = `tw-flex tw-w-full tw-items-center tw-justify-center ${forceIronBackground ? "!tw-bg-iron-900" : ""} tw-p-0 ${textCenter ? "tw-text-center" : ""} ${className ?? ""}`;
  let t4;
  if ($[0] !== t3) {
    t4 = t3.trim();
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== children || $[3] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[2] = children;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}